module.exports = __webpack_public_path__ + "204b447946aae5c9a991da3ddf6ead17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/9.jpg
// module id = 292
// module chunks = 0